import * as React from "react"
// helper
import { ISvgIcons } from "./helper"

export const LeftArrowIcon: React.FC<ISvgIcons> = ({
    className = "",
    ...rest
}) => (
    <svg
        viewBox="0 0 24 24"
        className={`${className}`}
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path d="M15 19.9201L8.47997 13.4001C7.70997 12.6301 7.70997 11.3701 8.47997 10.6001L15 4.08008" />
    </svg>
)
